import { PayloadGroupMockup } from '../../../../../../../components/Forms/constants';
import { fieldNamesForServerFactory } from '../../../../../../../helpers/fieldNamesForServerFactory';

import { PermitDataFieldName } from './types';

const payloadGroupName = 'permit';

export const permitDataPayloadGroupMockup: PayloadGroupMockup<typeof payloadGroupName> = {
  [payloadGroupName]: {
    id: null,
    type: null,
  },
};

export const permitDataFieldNamesForServer = fieldNamesForServerFactory({
  groupName: payloadGroupName,
  fields: [
    {
      localFieldName: PermitDataFieldName.permitType,
      serverFieldName: 'permit',
    },
  ],
});
